import React from 'react';
import PropTypes from 'prop-types';
import { ReviewEntities } from 'client/data/models/dealer-reviews';
import { REVIEWS_ALL } from 'client/constants/dealer-reviews';
import { getPlural } from 'client/utils/plural';
import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';

import './dealer-review-overall-rating.scss';

export function DealerReviewsOverallRating({ rating, reviewsType }) {
  const isAllTab = reviewsType === REVIEWS_ALL;

  return (
    <div className="overall-rating text-center mx-auto px-1_5 py-1_5 bg-cool-gray-90 rounded-16">
      <p className="size-16 text-cool-gray-30 fw-medium mb-0">Overall {isAllTab ? '' : `${reviewsType} `}rating</p>
      <p>Based on reviews posted in the prior 24 months.</p>
      <span className="size-48 fw-bold text-gray-darkest">{rating.averageRating.toFixed(1)}</span>
      <div className="mb-md-0_5">
        <RatingStars className="overall-rating-stars text-blue-50 px-0_5 size-24" rating={rating.averageRating} />
        <p className="medium text-cool-gray-40 mt-0_25 mb-0">
          ({rating.newReviewsCount} {getPlural('review', rating.newReviewsCount)})
        </p>
      </div>
      {isAllTab && (
        <div className="h6 text-gray-dark fw-normal">
          <hr className="mt-1" />
          <p className="medium text-cool-gray-40 mb-0_5">Customer recommendations:</p>
          <p className="size-14 text-cool-gray-40 mb-0">
            <span className="emoji" role="img" aria-hidden>
              👍
            </span>
            <span className="text-cool-gray-30 fw-bold ms-0_25">Yes </span>
            <span>({rating.recommended})</span>
            <span className="px-0_5">|</span>
            <span className="emoji" role="img" aria-hidden>
              👎
            </span>
            <span className="text-cool-gray-30 fw-bold ms-0_25">No </span>
            <span>({rating.notRecommended})</span>
          </p>
        </div>
      )}
    </div>
  );
}

DealerReviewsOverallRating.propTypes = {
  rating: ReviewEntities.OverallRatingEntity.isRequired,
  reviewsType: PropTypes.string.isRequired,
};
